module.exports = __webpack_public_path__ + "img/hi.51112aca.svg";